import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DsButtonModule, DsCheckboxModule, DsLabelModule } from '@bmw-ds/components';

import { CustomerVehicle, CustomerVehicleRelationType } from '../../../customer/model/customer-vehicle.model';
import { useI18n } from '../../../i18n/services/i18n.service';
import { VerifyChoiceModalWrapper } from '../../../modal/verify-choice-modal/verify-choice-modal.wrapper';
import { AddRelationModalContainer } from './add-relation-modal.container';

@Component({
  selector: 'cdf-add-relation-modal',
  imports: [
    DsButtonModule,
    VerifyChoiceModalWrapper,
    DsCheckboxModule,
    DsLabelModule,
    FormsModule,
    AddRelationModalContainer,
  ],
  template: `
    <cdf-verify-choice-modal-wrapper
      class="add-relation-modal"
      [open]="true"
      size="lg"
      [headingText]="i18n('vehicles.addRelationVerifyModal.heading')"
      [bodyText]="verifyAddRelationModalBody"
      [verifyButtonText]="i18n('vehicles.addRelationVerifyModal.addButton', { count: selectedCountMin1() })"
      [buttonLoading]="loading()"
      [disableVerifyButton]="selectedCount() === 0"
      (verify)="confirmAdd.emit(this.selectedRelations())"
      (closeEvent)="hideModal.emit()"
    />
    <ng-template #verifyAddRelationModalBody>
      <cdf-add-relation-modal-container [vehicle]="vehicle()" [(selectedRelations)]="selectedRelations" />
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddRelationModalWrapper {
  protected readonly i18n = useI18n();

  readonly vehicle = input.required<CustomerVehicle>();

  readonly loading = input(false);

  readonly selectedRelations = signal<ReadonlySet<CustomerVehicleRelationType>>(new Set());
  protected readonly selectedCount = computed(() => this.selectedRelations().size);

  /** The count of selected relations, but at least 1 for better UX of the button text */
  protected readonly selectedCountMin1 = computed(() => Math.max(this.selectedCount(), 1));

  readonly confirmAdd = output<ReadonlySet<CustomerVehicleRelationType>>();
  readonly hideModal = output();
}
